export default "__VITE_ASSET__CChaDblf__"